import axios from './axiosConfig'

export interface BranchOption {
 id: string
 name: string
 code: string
 is_main: boolean
}

export const branchesAPI = {
 listAccessible: async () => {
 const response = await axios.get<{ status: string; data: { branches: BranchOption[] }; message?: string }>(
 '/auth/branches'
 )
 return response.data
 },

 /** `null` clears current branch (global view); sends JSON `branch_id: null` as required by the API. */
 switchCurrent: async (branchId: string | null) => {
 const response = await axios.put<{
 status: string
 data: { user: Record<string, unknown> }
 message?: string
 }>('/auth/current-branch', { branch_id: branchId }, branchId ? {
 headers: { 'X-Branch-Id': branchId },
 } : undefined)
 return response.data
 },
}
